/**
 * 서버가 `error` 프레임으로 돌려주는 코드.
 *
 * 클라이언트는 code로 분기하고 message는 사람에게만 보여준다.
 * (message 문구는 언제든 바뀔 수 있다)
 */
export const ERROR_CODES = {
  /** 프레임이 스키마에 맞지 않음 */
  BAD_REQUEST: 'BAD_REQUEST',
  /** hello 전에 다른 프레임을 보냄 */
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
  /** memberToken이 위조되었거나 만료됨 */
  INVALID_TOKEN: 'INVALID_TOKEN',
  /** 초대코드에 해당하는 방이 없음 */
  ROOM_NOT_FOUND: 'ROOM_NOT_FOUND',
  /** owner가 방을 잠금 */
  ROOM_LOCKED: 'ROOM_LOCKED',
  /** 정원 초과 */
  ROOM_FULL: 'ROOM_FULL',
  /** 강퇴/차단된 사용자 */
  BANNED: 'BANNED',
  /** 레이트 리밋 초과 */
  RATE_LIMITED: 'RATE_LIMITED',
  /** 남의 메시지를 수정/삭제하려 함 */
  FORBIDDEN: 'FORBIDDEN',
  /** 대상 메시지가 없음 */
  MESSAGE_NOT_FOUND: 'MESSAGE_NOT_FOUND',
  /** 수정 가능 시간이 지남 */
  EDIT_WINDOW_CLOSED: 'EDIT_WINDOW_CLOSED',
  /** 닉네임이 이미 사용 중 */
  NICKNAME_TAKEN: 'NICKNAME_TAKEN',
  /** 클라이언트 프로토콜 버전이 서버와 호환되지 않음 */
  PROTOCOL_MISMATCH: 'PROTOCOL_MISMATCH',
  /**
   * 서버가 이 프레임을 아직 처리하지 못한다.
   *
   * 개발 중 미구현 구간을 가리키기도 하고, 배포 후에는 클라이언트가
   * 서버보다 새로울 때(자동 업데이트 시차) 나타난다. 둘 다 재시도로는
   * 해결되지 않으므로 클라이언트는 조용히 무시하고 넘어가야 한다.
   */
  NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
  /** 서버 내부 오류 */
  INTERNAL: 'INTERNAL',
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

/** 이 코드를 받으면 재연결해도 소용없다. 클라이언트는 백오프를 멈춰야 한다. */
export const FATAL_ERROR_CODES: ReadonlySet<ErrorCode> = new Set([
  ERROR_CODES.ROOM_NOT_FOUND,
  ERROR_CODES.ROOM_LOCKED,
  ERROR_CODES.BANNED,
  ERROR_CODES.PROTOCOL_MISMATCH,
]);

export function isFatalError(code: ErrorCode): boolean {
  return FATAL_ERROR_CODES.has(code);
}
